import MultipleStringsUI from "./MultipleStringsUI";

export default class MultipleStrings {

  private content: string[] = this.ui.getContent();
  private name: string = this.ui.getName();

  public constructor(private ui: MultipleStringsUI) {
    this.ui.render(this.content, this.name);
    this.ui.addButton();
  }
}
